module.exports = __webpack_public_path__ + "static/img/4.c0751a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/1/zh/4.png
// module id = T3bO
// module chunks = 0